import O1HD from "../../../../engines/gameEngine";


const { ccclass, property } = cc._decorator;
export enum cowRunType {
    one,
    two,
    three,
}
export enum CowAniType {
    default = 'default',
    Yellow = 'Yellow',
    Blue = 'Blue',
    NaiNiu = 'NaiNiu',
    Green = 'Green',
    Brown = 'Brown',
    Red = "Red"
}
export const CowIndexToSkin: CowAniType[] = [CowAniType.Yellow, CowAniType.Blue, CowAniType.NaiNiu, CowAniType.Green, CowAniType.Brown, CowAniType.Red]
@ccclass
export default class cowItem extends cc.Component {
    readonly SPEED: number = 200;
    @property({ type: cc.Node, displayName: "头部" })
    node_head: cc.Node = null;
    @property({ type: sp.Skeleton, displayName: "动画" })
    sp_cow: sp.Skeleton = null;
    speedBei: number = null;

    cowAniIndex: number = null
    async init(runWay: cowRunType, speedBei: number, cowWave: number, cowAniIndex: number) {
        return new Promise<void>(async resolve=>{
            this.speedBei = speedBei;
            this.cowAniIndex = cowAniIndex
            this.node.getChildByName("lab").getComponent(cc.Label).string = cowAniIndex + "";
            switch (runWay) {
                case cowRunType.one:{
                    await this.oneRun();
                    resolve();
                    break;
                }
                case cowRunType.two:
                    {
                        await this.twoRun(); 
                        resolve();
                        break;
                    } 
                case cowRunType.three:{
                    await this.threeRun(); 
                    resolve();
                    break;
                } 
            }
            
        });
        // let time = new Date().getTime()
        // this.dengjiaoAni(()=>{
        //     console.error(new Date().getTime()-time)
        // })
        
    }
    oneRun() {
        return new Promise<void>(resolve=>{
            let onePos: cc.Vec3 = cc.v3(600, 0)
            let one1Pos: cc.Vec3 = cc.v3(-600, 0)
            this.node.setPosition(onePos);
            let runtime = onePos.sub(one1Pos).mag() / (this.SPEED * this.speedBei);
            this.runAni()
            cc.tween(this.node)
                .tag(1)
                // .repeatForever(
                    // cc.tween()
                        .call(() => {
                            this.node.setPosition(onePos);
                        })
                        .to(runtime, { position: one1Pos })
                        .delay(5)
                        .call(resolve)
                        // )
                        
    
                // .to(runtime, { position: one1Pos })
                // .call(()=>{
                //     this.oneRun()
                // })
                .start();
        });
    }
    async twoRun() {
        return new Promise<void>(resolve=>{
            let onePos: cc.Vec3 = cc.v3(720, 0)
            let one1Pos: cc.Vec3 = cc.v3(-600, 0)
            this.node.setPosition(onePos);
            let runtime = onePos.sub(one1Pos).mag() / (this.SPEED * this.speedBei);
            this.runAni();
            cc.tween(this.node)
                .tag(1)
                // .repeatForever(
                // cc.tween()
                .call(() => {
                    this.node.setPosition(onePos);
                })
                .to(runtime, { position: one1Pos })
                .call(resolve)
                // )
                .start();
        });
    }

    threeRun() {
        return new Promise<void>(resolve=>{
            let onePos: cc.Vec3 = cc.v3(200, 0)
            let one1Pos: cc.Vec3 = cc.v3(-200, 0)
            this.node.setPosition(onePos);
            let runtime = onePos.sub(one1Pos).mag() / (this.SPEED * this.speedBei);
    
            cc.tween(this.node)
                .tag(1)
                // .repeatForever(
                    // cc.tween()
                        .call(() => {
                            this.changScale = false;
                            this.dengjiaoAni(() => {
                            });
                            this.node.scaleX = 1;
                            this.node.setPosition(onePos);
                        })
                        .delay(1.5)
                        
                        .call(() => {
                            
                            this.changScale = true;
                            this.runAni();
                        })
                        .to(runtime, { position: one1Pos })
                        .call(() => {
                            this.changScale = false;
                            this.node.scaleX = -1;
                            this.dengjiaoAni(() => {
                                // this.changScale = true;
                                // this.runAni();
                            });
                        })
                        .delay(1.5)
                        .call(() => {
                            this.changScale = true;
                            this.runAni();
                            resolve();
                        })
                        .to(runtime, { position: onePos })
                // )
                .start();
        });
    }

    runAni() {

        this.sp_cow.node.active = true
        this.sp_cow.setSkin(CowIndexToSkin[this.cowAniIndex] + "_Normal")
        this.sp_cow.setAnimation(0, "animation", true);
    }
    dengjiaoAni(call: () => void) {

        this.sp_cow.node.active = true
        this.sp_cow.setSkin(CowIndexToSkin[this.cowAniIndex] + "_Normal")
        this.sp_cow.setAnimation(0, "DengJiao", true);

        // this.sp_cow.setCompleteListener(() => {
        //     this.sp_cow.clearTracks()
        //     this.sp_cow.setCompleteListener(null);
        //     call && call();
        // })
    }
    playAniZhengzha() {
        this.node.pauseAllActions()
        this.sp_cow.node.active = false
    }
    playAniChaoxiao(sound:boolean = false) {
       if(sound) O1HD.getManagers().soundMgr.playSound('cow_chaoxiao',null,"takeCowGameBundle");
        this.node.pauseAllActions()
        this.sp_cow.node.active = true
        this.sp_cow.setSkin(CowIndexToSkin[this.cowAniIndex] + "_ChaoFeng")
        this.sp_cow.setAnimation(0, "ChaoFeng", true);
    }
    lastPos: cc.Vec2 = null;
    changScale: boolean = true;
    protected update(dt: number): void {
        if (!this.changScale) {
            this.lastPos = null;
            return;
        }
        if (this.lastPos != null && this.node.x != this.lastPos.x) {
            let scale = this.node.x > this.lastPos.x ? -1 : 1
            if (scale != this.node.scaleX) this.node.scaleX = scale
        }
        this.lastPos = cc.v2(this.node.x, this.node.y)
    }
}